// extracted by mini-css-extract-plugin
export default {"tab-item-container":"BaseTab_tab-item-container__mps5b"};